module.exports = __webpack_public_path__ + "img/Passed both chambers.5bb7e0e4.svg";